<page-heading [title]="isNew ? 'Adicionar' : 'Alterar' + ' Empresa'"
  [description]="'Preencha os dados para ' + (isNew ? 'adicionar' : 'atualizar') + ' uma empresa'"
  [hasBreadcrumb]="true" [breadcrumb]="breadcrumb" />

<form [formGroup]="formGroup">
  <div class="row">
    <div class="col-7">

      <div class="card">
        <h6 class="card-header">Dados</h6>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 mb-3">
              <label class="form-label">Nome *</label>
              <input type="text" class="form-control" maxlength="255" formControlName="name" required />
              <field-error-component [field]="'name'" [label]="'Nome'" [formGroup]="formGroup" />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 mb-3">
              <label class="form-label">Tipo *</label>
              <mat-select class="form-control" formControlName="type" required>
                <mat-option [value]="'IMAGE'">Imagem</mat-option>
              </mat-select>
              <field-error-component [field]="'type'" [label]="'Tipo'" [formGroup]="formGroup"></field-error-component>
            </div>
            <div class="col-lg-4 mb-3">
              <label class="form-label" for="startedAt">Data de Início <span class="text-danger">*</span></label>
              <div class="trend-datepicker">
                <input class="form-control" [matDatepicker]="pickerStartedAt" placeholder="00/00/0000"
                  formControlName="startedAt" [disabled]="true" />
                <mat-datepicker-toggle matSuffix [for]="pickerStartedAt" />
                <mat-datepicker #pickerStartedAt></mat-datepicker>
              </div>
              <field-error-component [field]="'startedAt'" [label]="'Data de Início'" [formGroup]="formGroup" />
            </div>
            <div class="col-lg-4 mb-3">
              <label class="form-label" for="finishedAt">Data de Fim <span class="text-danger">*</span></label>
              <div class="trend-datepicker">
                <input class="form-control" [matDatepicker]="pickerFinishedAt" placeholder="00/00/0000"
                  formControlName="finishedAt" [disabled]="true" />
                <mat-datepicker-toggle matSuffix [for]="pickerFinishedAt" />
                <mat-datepicker #pickerFinishedAt></mat-datepicker>
              </div>
              <field-error-component [field]="'finishedAt'" [label]="'Data de Fim'" [formGroup]="formGroup" />
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <h6 class="card-header">Imagem</h6>
        <div class="card-body">
          <div class="row position-relative">
            <div class="col-lg-12">
              <div class="upload-area">
                @if (loadingSpinner$ | async) {
                <loading-component class="loading" />
                } @else {
                @if ((info.type === 'IMAGE' || info.type === 'VIDEO') && !info.content) {
                <div class="placeholder-content" (click)="addImage()">
                  <i class="mdi mdi-cloud-upload-outline upload-icon text-primary"></i>
                  <p class="text-primary">Clique aqui para carregar</p>
                  <p class="text-muted">
                    PNG, JPG ou JPEG (MAX. 800x400px)
                  </p>
                </div>
                }
                }
                <div class="upload-area__image" [ngStyle]="
                    (loadingSpinner$ | async) ? { filter: 'blur(5px)' } : {}
                  ">
                  @if ((info.type === 'IMAGE' || info.type === 'VIDEO') && info.content) {
                  <img [src]="info.content" alt="Imagem da empresa" height="400" (click)="$event.stopPropagation()"
                    (error)="onImageLoadError()" />
                  <button class="btn btn-outline-danger" type="button"
                    (click)="removeMedia(); $event.stopPropagation()">
                    <i class="mdi mdi-trash-can-outline"></i>
                  </button>
                  }
                </div>
                <input #fileInputFile type="file" accept="image/jpeg, image/png" (change)="onSelectImage($event)" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 mb-3">
              <label class="form-label">URL *</label>
              <input type="text" class="form-control" maxlength="255" formControlName="contentUrl" required />
              <field-error-component [field]="'contentUrl'" [label]="'URL'" [formGroup]="formGroup" />
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="row position-relative">
            <div class="col-lg-12">
              <div class="d-flex gap-3 justify-content-start w-100">
                <button class="btn btn-outline-secondary" (click)="goBack()">
                  Cancelar
                </button>
                <button class="btn btn-primary" [disabled]="loading" (click)="onSubmit()">
                  {{ !loading ? (isNew ? "Salvar" : "Alterar") : "" }}
                  @if (loading) {
                  <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
                  }
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-5">
      <div class="card">
        <h6 class="card-header">Preview</h6>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12 mb-3">
              <div class="custom-switch">
                <input type="checkbox" id="activate" checked data-switch="success" formControlName="actived" />
                <label for="activate">
                  <span>{{ info?.actived ? "Desativar" : "Ativar" }}</span>
                </label>
              </div>
              <small>Utilize essa opção para a empresa como ativa ou inativa</small>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</form>